import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import pallet from '../../../layouts/pallet';
import { dataGridSx } from '../../common/styled/DataGrid';
import { ButtonWrapper, StyledButton } from '../styled';
import { DeclarationItem } from '../types';
import { getDeclarationColumns } from '../utils/editDeclarationColumns';
import tableColumnUtils from '../../../utils/tableColumnUtils';

interface DeclarationSetupTableAndActionsProps {
  declarations: DeclarationItem[];
  onEdit: (declarationItem: DeclarationItem) => void;
  onDelete: (declarationItem: DeclarationItem) => void;
  onAddDeclarationItem: (value: boolean) => void;
  onLabelClick: (declarationItem: DeclarationItem) => void;
  onCloneDeclarations: () => void;
}

const EditDeclarationTable: React.FC<DeclarationSetupTableAndActionsProps> = ({
  declarations,
  onEdit,
  onDelete,
  onAddDeclarationItem,
  onLabelClick,
  onCloneDeclarations
}) => {
  const columns = getDeclarationColumns(onEdit, onDelete, onLabelClick);

  return (
    <>
      <ButtonWrapper>
        {declarations.length === 0 && (
          <StyledButton sx={{ mb: 2 }} onClick={onCloneDeclarations}>
            Clone Declarations
          </StyledButton>
        )}

        <StyledButton sx={{ mb: 2 }} onClick={() => onAddDeclarationItem(true)}>
          Add Declaration
        </StyledButton>
      </ButtonWrapper>

      <DataGrid
        rowHeight={50}
        rows={declarations}
        getRowId={(row) =>
          row.id || `${row.label}-${row.sequenceNo || Math.random()}`
        }
        columns={columns}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </>
  );
};

export default EditDeclarationTable;
